<script lang="ts">
  import type { StatamicAsset, StatamicLink } from "@customTypes/statamic.js";
  import { convertStatamicAssetToCDN } from "@utils/cdn";

  export let assets_field: StatamicAsset;
  export let link: string | StatamicLink;

  const url = typeof link === "string" ? link : link?.url || "";
  const h1Classes = "mt-16 mb-8 md:mb-24 mx-auto flex justify-center";
  const imgSource = convertStatamicAssetToCDN(assets_field.id);
  const imgClasses = "w-auto max-h-[227px]";
  const imgAlt = assets_field.alt;
</script>

{#if !!url}
  <a href={url}>
    <h1 class={h1Classes}>
      <img src={imgSource} class={imgClasses} alt={imgAlt} />
    </h1>
  </a>
{:else}
  <h1 class={h1Classes}>
    <img src={imgSource} class={imgClasses} alt={imgAlt} />
  </h1>
{/if}
